import { TitleComponent } from "Components/Title";
import { RatioLimitModal } from "../Insurance/Components/RatioLimitModal";
import { ReactNode, useContext, useState } from "react";
import { CustomButton } from "Components/CustomButton";
import { SearchComponent } from "Components/SearchComponent";
import {
  GetPurposeCategoryEnum,
  PROP_NAME_CITY,
  PROP_NAME_INPUT_TEXT,
  PROP_NAME_MAIN_TAB,
  PROP_NAME_METHOD,
  PROP_NAME_PURPOSE,
  PROP_NAME_SKIP_ADS,
  PROP_NAME_SORTBY,
  PURPOSE_OPTIONS_V2,
} from "helpers/constants";
import { getCities } from "helpers/backend_helper";
import { useRequest } from "ahooks";
import { AdminContext } from "context/adminContext";
import { NotificationContext } from "context/notificationContext";
import { Badge, Divider } from "antd";
import { useSearchParams } from "react-router-dom";
import styles from "./index.module.css";
import { TabsComponent } from "Components/TabsComponent";
import { RequestTransactionsIns } from "./RequestTransactionsIns";

const items = [
  {
    key: "0",
    label: (
      <Badge count={0} size="small" className={styles.badge}>
        <div className={styles.deals}>All</div>
      </Badge>
    ),
    children: <RequestTransactionsIns status="" />,
  },
  {
    key: "1",
    label: (
      <Badge count={0} size="small" className={styles.badge}>
        <div className={styles.deals}>Incoming</div>
      </Badge>
    ),
    children: <RequestTransactionsIns status="incoming" />,
  },
  {
    key: "2",
    label: (
      <Badge count={0} size="small" className={styles.badge}>
        <div className={styles.deals}>Outgoing</div>
      </Badge>
    ),
    children: <RequestTransactionsIns status="outgoing" />,
  },
];

export const TransactionInsurance = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [isRatioOpened, setIsRatioOpened] = useState(false);
  const onOpenRatioModal = () => setIsRatioOpened(true);
  const onCloseRatioModal = () => setIsRatioOpened(false);

  const { localCountry } = useContext(AdminContext);
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const [cities, setCities] = useState<{ label: string | ReactNode; value: string }[]>([]);

  const { loading: getCitiesLoading } = useRequest(() => getCities(localCountry.iso, true), {
    refreshDeps: [localCountry],
    onError: (error: any) => {
      openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
    },
    onSuccess: (data) => {
      setCities(() => {
        return [
          { label: "All", value: "" },
          ...data.cities.map((city) => {
            const upperCaseFirstLt = city.formattedData[0].toUpperCase() + city.formattedData.slice(1);
            return { label: upperCaseFirstLt, value: city.id };
          }),
        ];
      });
    },
  });
  return (
    <>
      <div>
        <div style={{ marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <TitleComponent text="Transactions & Insurance" />
          <CustomButton sizeButton="medium" typeButton="secondary" onClick={onOpenRatioModal}>
            Ratio Limits
          </CustomButton>
        </div>
        <SearchComponent
          inputData={{
            palceHolder: "Search",
            queryTextName: PROP_NAME_INPUT_TEXT,
          }}
          selectData={[
            {
              options: cities,
              label: "City",
              isLoadingSelect: getCitiesLoading,
              queryName: PROP_NAME_CITY,
            },
            {
              options: [
                { label: "All", value: "" },
                { label: "Bank", value: "Card" },
                { label: "Crypto", value: "Wallet" },
              ],
              label: "Method",
              isLoadingSelect: false,
              queryName: PROP_NAME_METHOD,
            },
            {
              options: [
                { label: "All", value: "" },
                { label: PURPOSE_OPTIONS_V2.Rent, value: GetPurposeCategoryEnum.Rent },
                { label: PURPOSE_OPTIONS_V2.Insurance, value: GetPurposeCategoryEnum.Insurance },
                { label: PURPOSE_OPTIONS_V2.Deposit, value: GetPurposeCategoryEnum.Deposit },
                { label: PURPOSE_OPTIONS_V2.DepositUnhold, value: GetPurposeCategoryEnum.DepositUnhold },
                { label: PURPOSE_OPTIONS_V2.DepositHold, value: GetPurposeCategoryEnum.DepositHold },
                { label: PURPOSE_OPTIONS_V2.Debt, value: GetPurposeCategoryEnum.Debt },
                { label: PURPOSE_OPTIONS_V2.RentalAndDeposit, value: GetPurposeCategoryEnum.RentalAndDeposit },
                { label: PURPOSE_OPTIONS_V2.RentalAndInsurance, value: GetPurposeCategoryEnum.RentalAndInsurance },
                { label: PURPOSE_OPTIONS_V2.CardLink, value: GetPurposeCategoryEnum.CardLink },
                { label: PURPOSE_OPTIONS_V2.Referral, value: GetPurposeCategoryEnum.Referral },
                { label: PURPOSE_OPTIONS_V2.Refund, value: GetPurposeCategoryEnum.Refund },
              ],
              label: "Purpose",
              isLoadingSelect: false,
              queryName: PROP_NAME_PURPOSE,
            },
          ]}
          isDateRangeField
        />
        <Divider style={{ borderWidth: 2 }} />
        <TabsComponent
          defaultActiveKey={searchParams.get(PROP_NAME_MAIN_TAB) || "0"}
          items={items}
          className={styles.tabs}
          destroyInactiveTabPane
          onChange={(activeKey) => {
            searchParams.set(PROP_NAME_MAIN_TAB, items.find((v) => v.key === activeKey).key);
            searchParams.delete(PROP_NAME_SORTBY);
            searchParams.delete(PROP_NAME_SKIP_ADS);

            setSearchParams(searchParams, { replace: true });
          }}
        />
      </div>
      <RatioLimitModal isOpen={isRatioOpened} onClose={onCloseRatioModal} />
    </>
  );
};
